import { Fill, Icon as Vector_icon, Style as Vector_style, Stroke } from 'ol/style';

// const DEFAULT_STAY_ICON_src:string = "/static/images/icons/agSelectStayIconTP.svg";
const DEFAULT_STAY_ICON_src:string = "/static/images/icons/tripPlannerIcons/campgroundPin_addedCamp.svg";
// const DEFAULT_ALT_STOP_ICON_src:string = "/static/images/icons/red-dot.webp";
const DEFAULT_ALT_STOP_ICON_src:string = "/static/images/icons/tripPlannerIcons/campgroundPin.svg";
const DEFAULT_HIGHLIGHT_ICON_src:string = "/static/images/icons/tripPlannerIcons/campgroundPin.svg";

const S2N_STAY_ICON_src:string = "/static/images/icons/tripPlannerIcons/Spot2nite.svg";

const FAVORITED_CAMP_ICON_src:string = "/static/images/icons/tripPlannerIcons/favoritedCampPin.svg";

export const DEFAULT_LOCKED_STOP_ICON_src:string = "/static/images/icons/tripPlannerIcons/userStopPin.svg";
export const DEFAULT_UNLOCKED_STOP_ICON_src:string = "/static/images/icons/tripPlannerIcons/suggestedStopPin.svg";
export const DEFAULT_LOCKED_STOP_ICON_W_POIS_src:string = "/static/images/icons/tripPlannerIcons/userStopPin.svg";
export const DEFAULT_UNLOCKED_STOP_ICON_W_POIS_src:string = DEFAULT_UNLOCKED_STOP_ICON_src;


export const mapLayerIds = ["main","sat","carnav"];

export const iconEnlargementFactor = 1.75;


export const routeStyle = new Vector_style({
    stroke: new Stroke({
        color: 'rgb(42, 37, 80)',
        width: 3
    })
});

export const stayMarkerStyle = new Vector_style({
    image: new Vector_icon({
        src: DEFAULT_STAY_ICON_src,
        scale: 1.2
    })
});
export const stayMarkerStyle_large = new Vector_style({
    image: new Vector_icon({
        src: DEFAULT_STAY_ICON_src,
        scale: 2.4
    })
});



export const stopMarkerStyle = new Vector_style({
    image: new Vector_icon({
        src: DEFAULT_LOCKED_STOP_ICON_src
    })
});

export const potentialStayStyle = new Vector_style({
    image: new Vector_icon({
        src: DEFAULT_ALT_STOP_ICON_src
    })
});

export const stayMarkerStyle_favorited = new Vector_style({
    image: new Vector_icon({
        src: FAVORITED_CAMP_ICON_src,
        scale: 1
    })
})

export const stayMarkerStyle_s2n = new Vector_style({
    image: new Vector_icon({
        src: S2N_STAY_ICON_src,
        scale: 0.075
    })
});

export const highlightedMarkerStyle = new Vector_style({
    image: new Vector_icon({
        src: DEFAULT_HIGHLIGHT_ICON_src,
        scale: 2
    })
});

export const stopCircleStyle_userStop = new Vector_style({
    stroke: new Stroke({
        color: 'orange',
        width: 5
    }),
    fill: new Fill({
        color: 'rgba(244, 130, 49, 0.1)'
    })
});

export const stopCircleStyle_agStops = new Vector_style({
    stroke: new Stroke({
        color: 'blue',
        width: 5
    }),
    fill: new Fill({
        color: 'rgba(0, 0, 255, 0.1)'
    })
});

export const errorRouteIconStyle = new Vector_style({
	image: new Vector_icon({
		src: "/static/images/icons/caution.svg",
		scale: 0.08,
		offset: [10,0]
	}),
	zIndex: 6
});

export const errorRouteStyle = new Vector_style({
    fill: new Fill({
        color: 'rgba(255, 0, 0, 0.8)' // Red color
    }),
    stroke: new Stroke({
        color: '#ff0000', // Red color
        width: 4
    })
});